import { useUserContext } from "app/contexts";

export function usePersonalApiKeysEnabled() {
  const { currentUser } = useUserContext();

  // Personal API Keys are only available for non SSO users
  return !currentUser.ssoUser;
}
